var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash"},[_c('div',{staticClass:"logo-container"},[_c('img',{staticClass:"logo",attrs:{"src":require(("@/assets/img/" + _vm.whitelabelPath + "/logo/logo.png"))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }